import { render, staticRenderFns } from "./PopTerm1.vue?vue&type=template&id=17f972bf&scoped=true&"
import script from "./PopTerm1.vue?vue&type=script&lang=js&"
export * from "./PopTerm1.vue?vue&type=script&lang=js&"
import style0 from "./PopTerm1.vue?vue&type=style&index=0&id=17f972bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f972bf",
  null
  
)

export default component.exports